export enum BOOKING_TYPES {
  HOTEL = "HOTEL",
  FLIGHT = "FLIGHT",
  TOUR = "TOUR",
}
